import { render, staticRenderFns } from "./SubGroupObservation.vue?vue&type=template&id=136c72d0"
import script from "./SubGroupObservation.vue?vue&type=script&lang=js"
export * from "./SubGroupObservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports